export var STORE_FINDER_PATTERN='/storefinder';